import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import configfile from "../config/config";
import apis from "./mixins/api";
import axios from "./axios";
import { customMixins } from "@/mixins/index.js";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "./style/main.scss";
import dayjs from 'dayjs';
import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import "regenerator-runtime/runtime";

Vue.prototype.$axios = axios;
Vue.prototype.GLOBAL = configfile.config;
Vue.prototype.$moment = moment;
Vue.prototype.$daysjs = dayjs;
Vue.use(DatePicker);
Vue.mixin(apis);
Vue.mixin(customMixins);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
